import { render } from "./Impressum.vue?vue&type=template&id=246abb24&lang=pug"
import script from "./Impressum.vue?vue&type=script&setup=true&lang=js"
export * from "./Impressum.vue?vue&type=script&setup=true&lang=js"

import "./Impressum.vue?vue&type=style&index=0&id=246abb24&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__